import { createFileRoute } from '@tanstack/react-router'

import { EditClientPage } from '@/pages/clients/[id]/edit/EditClientPage'

export const Route = createFileRoute('/_authenticated/_dashboard/clients/$id/edit/')({
  component: EditClientPage,
})
